import React from "react";
import { Divider } from "styled_components/Common/Divider";
import styled from "styled-components";
import { Font } from "./Font";

const FontsStyle = styled.div`
  .font-display {
    display: flex;
    flex-direction: column;
    .font-section {
      position: relative;
      display: flex;
      flex-wrap: wrap;

      .heading {
        width: 100%;
        height: 50px;
        padding-top: 10px;
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

const headingFonts = [
  {
    name: "Heading30",
    font: "heading30",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "20px, 24px, 34px",
    lineHeight: "1px",
    letterSpacing: "1px, 1.2px, 1.7px",
  },

  {
    name: "Heading52",
    font: "heading52",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "15px, 18px, 24px",
    lineHeight: "16px ,24px,24px",
    letterSpacing: "0.75px",
  },
  {
    name: "Heading60",
    font: "heading60",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "20px, 24px, 34px",
    lineHeight: "12px,14px,20px",
    letterSpacing: "1px, 1.2px, 1.7px",
  },
  {
    name: "Heading70",
    font: "heading70",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "16px, 20px, 30px",
    lineHeight: "16px,14px,30px",
    letterSpacing: "0.8px, 1px, 1.2px",
  },
  {
    name: "Heading71",
    font: "heading71",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "16px, 20px, 30px",
    lineHeight: "16px,20px,30px",
    letterSpacing: "0.8px, 1px, 1.2px",
  },
  {
    name: "Heading76",
    font: "heading76",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 22px",
    lineHeight: "14px,18px,22px",
    letterSpacing: "0.5px",
  },
  {
    name: "Heading80",
    font: "heading80",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 18px, 22px",
    lineHeight: "14px,18px,22px",
    letterSpacing: "1px, 1.35px, 1.65px",
  },
  {
    name: "Heading90",
    font: "heading90",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "12px, 14px, 18px",
    lineHeight: "12px,14px,18px",
    letterSpacing: "0.6px,0.7px,0.9px",
  },
  {
    name: "Heading91",
    font: "heading91",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "12px, 14px, 18px",
    lineHeight: "12px,14px,18px",
    letterSpacing: "0.5px",
  },
];
const headerFonts = [
  {
    name: "Header10",
    font: "header10",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Header11",
    font: "header11",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Header20",
    font: "header20",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "20px, 24px, 30px",
    lineHeight: "20px,24px,30px",
    letterSpacing: "0.5px,0.5px,0.5px",
  },
  {
    name: "Header21",
    font: "header21",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "20px, 24px, 30px",
    lineHeight: "20px,24px,30px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Header30",
    font: "header30",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "12px, 14px, 16px",
    lineHeight: "12px,14px,16px",
    letterSpacing: "1px,1px,1px",
  },
  {
    name: "Header50",
    font: "header50",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "0.15px,0.15px,0.15px",
  },
  {
    name: "Header51",
    font: "header51",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "0.15px,0.15px,0.15px",
  },
  {
    name: "Header52",
    font: "header52",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "15px, 18px, 24px",
    lineHeight: "15px,18px,24px",
    letterSpacing: "0.75px,0.75px,0.75px",
  },
];
const footerFonts = [
  {
    name: "Footer11",
    font: "footer11",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "13px, 14px, 16px",
    lineHeight: "13px,14px,16px",
    letterSpacing: "0.5px,0.5px,0.5px",
  },
  {
    name: "Footer14",
    font: "footer14",
    fontName: "ProximaNova-Regular",
    fontSizes: "12px, 14px, 18px",
    lineHeight: "12px,14px,18px",
    letterSpacing: "0px,0px,0px",
  },
  {
    name: "Footer15",
    font: "footer15",
    fontName: "ProximaNova-Bold",
    fontSizes: "12px, 14px, 18px",
    lineHeight: "12px,14px,18px",
    letterSpacing: "0px,0px,0px",
  },
  {
    name: "Footer16",
    font: "footer16",
    fontName: "ProximaNova-Light",
    fontSizes: "12px, 13px, 15px",
    lineHeight: "24px,24px,24px",
    letterSpacing: "0px,0px,0px",
  },
  {
    name: "Footer20",
    font: "footer20",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 22px",
    lineHeight: "24px,32px,48px",
    letterSpacing: "0.15px,0.15px,0.15px",
  },
  {
    name: "Footer21",
    font: "footer21",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 18px, 22px",
    lineHeight: "24px,32px,48px",
    letterSpacing: "0.15px,0.15px,0.15px",
  },
  {
    name: "Footer30",
    font: "footer30",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 16px, 20px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer31",
    font: "footer31",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 16px, 20px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer40",
    font: "footer40",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 16px, 20px",
    lineHeight: "14px,16px,20px",
    letterSpacing: "0.15px,0.15px,0.15px",
  },
  {
    name: "Footer50",
    font: "footer50",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer51",
    font: "footer51",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px,18px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer60",
    font: "footer60",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "16px, 20px, 24px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer61",
    font: "footer61",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "16px, 20px, 24px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
  {
    name: "Footer70",
    font: "footer70",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "18px, 22px, 32px",
    lineHeight: "18px,22px,32px",
    letterSpacing: "1.5px,1.5px,1.5px",
  },
];
const labelFonts = [
  {
    name: "Labels11",
    font: "labels11",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "12px, 13px, 16px",
    lineHeight: "12px,13px,16px",
    letterSpacing: "0px,0px,0px",
  },
  {
    name: "Labels20",
    font: "labels20",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "11px, 14px, 18px",
    lineHeight: "13px,14px,18px",
    letterSpacing: "0.5px,0.5px,0.5px",
  },
  {
    name: "Labels21",
    font: "labels21",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "13px, 14px, 18px",
    lineHeight: "13px,14px,18px",
    letterSpacing: "0px,0px,0px",
  },
];

const formsFonts = [
  {
    name: "Forms 70",
    font: "forms70",
    fontName: "ProximaNova-Light",
    fontSizes: "16px, 20px, 24px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "10%,10%,10%",
  },
  {
    font: "forms71",
    name: "Forms 71",
    fontName: "ProximaNova-Bold",
    fontSizes: "16px, 20px, 24px",
    lineHeight: "16px,20px,24px",
    letterSpacing: "10%,10%,10%",
  },
  {
    name: "Forms dropdown selection",
    font: "form-dropdown-selection",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "uses size map function - 11px, 16px, 20px",
    lineHeight: "1.19",
    letterSpacing: "0.8px",
  },
  {
    name: "Form  Label Float",
    font: "form-label-float",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "uses size map function - 12px, 16px, 20px",
    lineHeight: "16px",
    letterSpacing: "0px",
  },
  {
    name: "Form hint text",
    font: "form-hint-text",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "uses size map function - 12px, 14px, 16px",
    lineHeight: "uses line height function - 12px, 14px, 16px",
    letterSpacing: "0px",
  },
  {
    name: "Form ghost text",
    font: "form-ghost-text",
    fontName: "ProximaNova-Regular",
    fontSizes: "uses size map function - 13px, 15px, 16px",
    lineHeight: "1.2",
    letterSpacing: "normal",
  },
  {
    name: "Form character count",
    font: "form-character-count-text",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "uses size map function - 22px, 30px, 34px",
    lineHeight: 1,
    letterSpacing: "-1.2px",
  },
];
const buttonsFonts = [
  {
    name: "Buttons 10",
    font: "buttons10",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "14px,14px,14px",
    letterSpacing: "0.7px,0.8px,0.9px",
  },
  {
    name: "Buttons 11",
    font: "buttons11",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "14px,16px,18px",
    letterSpacing: "0.7px,0.8px,0.9px",
  },
  {
    name: "Buttons 20",
    font: "buttons20",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "13px, 16px, 20px",
    lineHeight: "0px",
    letterSpacing: "0px",
  },
  {
    name: "Buttons 21",
    font: "buttons21",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "13px, 16px, 20px",
    lineHeight: "default",
    letterSpacing: "default",
  },
  {
    name: "Buttons 25",
    font: "buttons25",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "default",
    letterSpacing: "default",
  },
  {
    name: "Buttons 26",
    font: "buttons26",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "15px, 16px, 20px",
    lineHeight: "default",
    letterSpacing: "default",
  },
  {
    name: "Buttons 27",
    font: "buttons27",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "15px, 16px, 20px",
    lineHeight: "14px",
    letterSpacing: "default",
  },
  {
    name: "Buttons 30",
    font: "buttons30",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 16px, 24px",
    lineHeight: "default",
    letterSpacing: "default",
  },
  {
    name: "Buttons 31",
    font: "buttons31",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "14px, 16px, 24px",
    lineHeight: "default",
    letterSpacing: "default",
  },
  {
    name: "Buttons 41",
    font: "buttons41",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "12px, 18px, 24px",
    lineHeight: "default",
    letterSpacing: "0.8px,0.9px,1.2px",
  },
  {
    name: "Buttons 51",
    font: "buttons51",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "16px, 18px, 32px",
    lineHeight: "default",
    letterSpacing: "default",
  },
];
const numbersFonts = [
  {
    name: "Numbers 5",
    font: "numbers5",
    fontName: "ProximaNova-Regular",
    fontSizes: "12px, 14px, 16px",
    lineHeight: "12px,12px,14px",
    letterSpacing: "-0.6px,-0.7px,-0.8px",
  },
  {
    name: "Numbers 7",
    font: "numbers7",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "18px, 22px, 28px",
    lineHeight: "16px,18px,24px",
    letterSpacing: "0.9px,1.1px,1.4px",
  },
  {
    name: "Numbers 10",
    font: "numbers10",
    fontName: "ProximaNova-Regular",
    fontSizes: "14px, 20px, 28px",
    lineHeight: "14px,20px,28px",
    letterSpacing: "-0.7px,-1px,-1.4px",
  },
  {
    name: "Numbers 20",
    font: "numbers20",
    fontName: "ProximaNova-Light",
    fontSizes: "26px, 28px, 46px",
    lineHeight: "26px,28px,46px",
    letterSpacing: "-1.3px,-1.4px,-2.3px",
  },
  {
    name: "Numbers 30",
    font: "numbers30",
    fontName: "ProximaNova-Light",
    fontSizes: "36px, 46px, 60px",
    lineHeight: "36px,46px,60px",
    letterSpacing: "-1.8px,-2.3px,-3px",
  },
];
const navFonts = [
  {
    name: "Nav Menu",
    font: "nav-menu",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "16px, 18px, 29px",
    lineHeight: "16px, 18px, 29px",
    letterSpacing: "1px",
  },
  {
    name: "Nav Secondary",
    font: "nav-secondary",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px, 18px, 24px",
    letterSpacing: "0.15px",
  },
  {
    name: "Nav Primary",
    font: "nav-primary",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 18px, 24px",
    lineHeight: "14px, 18px, 24px",
    letterSpacing: "1.5px",
  },
];
const fonts = [
  {
    name: "Body10",
    font: "body10",
    fontName: "ProximaNova-Regular",
    fontSizes: "12px, 14px, 16px",
    lineHeight: "1.5, 1.43, 1.38",
    letterSpacing: "0.15px",
  },
  {
    name: "Body20",
    font: "body20",
    fontName: "ProximaNova-Regular",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "1.43, 1.38, 1.33",
    letterSpacing: "normal",
  },
  {
    name: "Body21",
    font: "body21",
    fontName: "ProximaNova-Bold",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "1.43px, 1.38px, 1.33px",
    letterSpacing: "0.15px",
  },
  {
    name: "Body30",
    font: "body30",
    fontName: "ProximaNova-Regular",
    fontSizes: "16px, 18px, 20px",
    lineHeight: "22px, 24px, 26px",
    letterSpacing: "normal",
  },
  {
    name: "Body40",
    font: "body40",
    fontName: "ProximaNova-Regular",
    fontSizes: "18px, 20px, 22px",
    lineHeight: "1.33px, 1.3px, 1.27px",
    letterSpacing: "normal",
  },
  {
    name: "Body Copy",
    font: "body-copy",
    fontName: "ProximaNova-Regular",
    fontSizes: "uses size map function - 11px, 13px, 15px",
    lineHeight: "1.08",
    letterSpacing: "normal",
  },
  {
    name: "Body Copy small regular",
    font: "body-copy-small-regular",
    fontName: "ProximaNova-Regular",
    fontSizes: "uses size map function - 9px, 11px, 12px",
    lineHeight: " uses function - 12px, 13px, 14px",
    letterSpacing: "normal",
  },
];
const miscFonts = [
  {
    name: "Global Bubbles",
    font: "globalbubbles10",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "14px, 16px, 18px",
    lineHeight: "1px",
    letterSpacing: "normal",
  },
  {
    name: "Profile card label",
    font: "profile-card-label",
    fontName: "ProximaNova-Regular",
    fontSizes: "11px, 11px, 13px",
    lineHeight: "1",
    letterSpacing: "",
  },
  {
    name: "Profile card field",
    font: "profile-card-field",
    fontName: "ProximaNova-Regular",
    fontSizes: "12px, 13px, 16px",
    lineHeight: "1",
    letterSpacing: "",
  },
  {
    name: "Primary 60",
    font: "primary60",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "24px, 32px, 48px",
    lineHeight: "24px, 32px, 48px",
    letterSpacing: "0%",
  },
  {
    name: "Callout small",
    font: "callout-sm",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "size map function - 10px, 12px, 14px",
    lineHeight: "line height function - 10px, 12px, 15px",
    letterSpacing: "0px",
  },
  {
    name: "Callout large",
    font: "callout-lg",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "size map function - 13px, 15px, 17px",
    lineHeight: "1.2",
    letterSpacing: "",
  },
  {
    name: "Status Head",
    font: "status-status-head",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "size map function - 12px, 13px, 14px",
    lineHeight: "1.08",
    letterSpacing: "normal",
  },

  {
    name: "Section Head",
    font: "heading-section-head",
    fontName: "Bourgeois-MediumCondensed",
    fontSizes: "size map function - 16px, 22px, 28px",
    lineHeight: "line height function - 16px, 22px, 29px",
    letterSpacing: "0px",
  },
  {
    name: "Section Label",
    font: "section-label",
    fontName: "Bourgeois-BoldCondensed",
    fontSizes: "size map function - 10px, 12px, 16px",
    lineHeight: "1",
    letterSpacing: "0.3px",
  },
  {
    name: "Section Content",
    font: "section-content",
    fontName: "ProximaNova-Regular",
    fontSizes: "size map function - 8px, 9px, 10px",
    lineHeight: "1.18",
    letterSpacing: "normal",
  },
  {
    name: "Total Amount Due ",
    font: "total-amount-due-primary-text",
    fontName: "ProximaNova-Light",
    fontSizes: "36px, 46px, 60px",
    lineHeight: "36px,46px,60px",
    letterSpacing: "-1.8px,-2.3px,-3px",
  },
  {
    name: "Total Amount Due subtext",
    font: "total-amount-due-subtext",
    fontName: "ProximaNova-Regular",
    fontSizes: "16px, 16px, 18px",
    lineHeight: "20px,22px,24px",
    letterSpacing: "",
  },
  {
    name: "Total Amount Due subtext - BOLD",
    font: "total-amount-due-subtext-bold",
    fontName: "ProximaNova-Bold",
    fontSizes: "16px, 16px, 18px",
    lineHeight: "22px,22px,24px",
    letterSpacing: "",
  },
];

export const Fonts = () => {
  return (
    <FontsStyle>
      <div className="font-display">
        <div className="font-section">
          <Divider />
          <div className="heading">Heading Fonts :</div>
          {headingFonts && headingFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Header Fonts :</div>
          {headerFonts && headerFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Body Fonts :</div>
          {fonts && fonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Footer Fonts :</div>
          {footerFonts && footerFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Label Fonts :</div>
          {labelFonts && labelFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Forms Fonts :</div>
          {formsFonts && formsFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Misc :</div>
          {miscFonts && miscFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Buttons :</div>
          {buttonsFonts && buttonsFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Numbers :</div>
          {numbersFonts && numbersFonts.map((font) => <Font font={font} />)}
        </div>
        <div className="font-section">
          <Divider />
          <div className="heading">Nav :</div>
          {navFonts && navFonts.map((font) => <Font font={font} />)}
        </div>
      </div>
    </FontsStyle>
  );
};
